/**
 * Detects if the current page load was a refresh or initial navigation
 * Uses Navigation Timing API
 */
class RefreshDetector {
    /**
     * Check if current page load is a refresh
     * @returns {boolean} true if page was refreshed, false if direct navigation
     */
    isPageRefresh() {
        const navEntries = performance.getEntriesByType('navigation');
        if (navEntries.length > 0) {
            const navType = navEntries[0].type;
            // Returns true for 'reload', false for 'navigate', 'back_forward', 'prerender'
            return navType === 'reload';
        }
        
        // Fallback: if API not available, default to false (don't restore)
        return false;
    }
}

export default new RefreshDetector();
